import { createFlickity } from './flickity';

export function init() {
	let elements = Array.from(document.querySelectorAll('.js-image-carousel'));

	elements.forEach(element => createFlickity(element, {
		cellAlign: 'left',
		contain: true,
		pageDots: false,
	}));
}
